import React, { ReactElement, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';

export default function RegisterGeneratePasses(): ReactElement | null {
  const { registrationId } = useParams<{ registrationId: string }>();
  const [error, setError] = useState<string>('');
  if (error) setError('Could not record your information. Please try again later');
  return <Redirect to={`/resident/host-registration/${registrationId}/receipt`} />;
}
